'use client';

import { useState } from 'react';
import { LinkIcon, CheckIcon } from 'lucide-react';
import { cn } from '@/utils/cn';
import { copyToClipboard } from '@/utils/clipboard';

export function CopyAnchorButton({ anchorId }: { anchorId: string }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const url = `${window.location.origin}${window.location.pathname}#${anchorId}`;
    try {
      await copyToClipboard(url);
    } catch {
      // Clipboard may be unavailable (e.g. insecure context); fail silently.
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      aria-label="Copy link to this section"
      title={copied ? 'Link copied' : 'Copy link to this section'}
      className={cn(
        'inline-flex flex-shrink-0 items-center justify-center ml-3 text-zinc-500 transition hover:text-white focus:opacity-100 focus:outline-none focus-visible:outline-none md:opacity-0 md:group-hover:opacity-100',
        copied && 'opacity-100 md:opacity-100'
      )}
    >
      {copied ? (
        <CheckIcon className="w-5 h-5 text-green-500" />
      ) : (
        <LinkIcon className="w-5 h-5" />
      )}
    </button>
  );
}
